import { render, staticRenderFns } from "./InviteTab.vue?vue&type=template&id=c81a5b32&scoped=true"
import script from "./InviteTab.vue?vue&type=script&lang=js"
export * from "./InviteTab.vue?vue&type=script&lang=js"
import style0 from "./InviteTab.vue?vue&type=style&index=0&id=c81a5b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81a5b32",
  null
  
)

export default component.exports